<section>

  <div class="container mb-6">
    <div class="row">

      <div class="col-12 col-md-8 col-lg-8 offset-lg-0">

        <div class="post-header">
          <div class="h5 mb-3">#knowledge</div>
          <h2 class="mb-5 heading-xl">
            Kostenfreies Webinar: <br> KI-Recruiting

          </h2>
        </div>

        <div class="post-meta">
          <div class="row align-items-center">

            <div class="col-auto">
              <div class="row align-items-center">
                <div class="image col-auto">
                  <sc-avatar size="xs" [user]="author"></sc-avatar>
                </div>
                <div class="name col ms-n3">
                  <div class="name fw-bold">Lars Branscheid</div>
                </div>
              </div>

            </div>

            <div class="col-auto">
              <div class="timestamp">24.04.2025</div>
            </div>

          </div>

        </div>
      </div>

    </div>
  </div>

  <div class="container-fluid mb-6">

    <div class="row">

      <div class="col-12">
        <img src="/assets/img/ai.jpg" class="img-fluid post-banner" />
      </div>

    </div>

  </div>

  <div class="container">

    <div class="row">

      <div class="col-12 col-lg-6 offset-lg-3">

        <div class="post-content">

          <p class="mb-6">
            Künstliche Intelligenz im Recruiting erfährt aktuell enorme Aufmerksamkeit. In der Praxis haben die meisten Unternehmen die strategische Relevanz erkannt. Gleichzeitig ist es sehr schwer, angesichts der Vielzahl von Anbietern und der Komplexität des Themas den Überblick zu behalten. Unsere Webinar-Reihe vermittelt dir unser Praxiswissen aus über 10 Jahren Active Sourcing und der Entwicklung Deutschlands führender Active Sourcing KI. Mit diesem Wissen bist du bestens vorbereitet, um dein Unternehmen auf dem Weg zum erfolgreichen Einsatz von KI zu begleiten und folgenschwere Fallstricke zu vermeiden.
          </p>

          <strong>
            Unsere kostenfreien Webinare:
          </strong>

          <br> <br>

          <h3>
            Basis | Überblick KI im Recruiting
          </h3>

          <p>
            Alles, was du wissen musst, um das Thema für dich einzuordnen. <br>
            Referent: Jonas Krömer (Co-Founder)
          </p>

          <p>
            Das erwartet dich:
          </p>

          <ul>
            <li class="mb-2">Wo kommt all die KI her?</li>
            <li class="mb-2">Was sind Einsatzgebiete im Recruiting?</li>
            <li class="mb-2">Welche konkreten Anbieter im Markt gibt es?</li>
            <li class="mb-2">Worauf muss ich achten (EU AI Act und Diskriminierung)?</li>
          </ul>

          <p>
            Termine
          </p>

          <ul>
            <li>07. August 2025</li>
            <li>04. September 2025</li>
            <li>02. Oktober 2025</li>
            <li>30. Oktober 2025</li>
            <li>27. November 2025</li>
          </ul>

          <div class="row align-items-center mt-5">
          <div class="col-auto">
            <button class="btn btn-lg btn-round btn-primary" (click)="goToBooking('webinar-basis-ki')">Jetzt kostenlos anmelden!</button>
          </div>
        </div>

          <h3 class="mt-6">
            Deep Dive | Künstliche Intelligenz
          </h3>

          <p>
            Wenn du tiefer ins Thema einsteigen möchtest. <br>
            Referenten: Marc Branscheid (CTO), Jonas Krömer (Co-Founder)

          </p>

          <p>
            Das erwartet dich:
          </p>

          <ul>
            <li class="mb-2">Was sind die Besonderheiten der KI-Entwicklung?</li>
            <li class="mb-2">Wie kann ich den Impact von KI erkennen?</li>
            <li class="mb-2">Wie unterscheiden sich KI-Modelle voneinander?</li>
            <li class="mb-2">Wie kann KI verantwortungsvoll entwickelt werden?</li>
          </ul>

          <p>
            Termine
          </p>

          <ul>
            <li>26. August 2025</li>
            <li>21. Oktober 2025</li>
          </ul>

          <div class="row align-items-center mt-5">
          <div class="col-auto">
            <button class="btn btn-lg btn-round btn-primary" (click)="goToBooking('webinar-deep-dive-ki')">Jetzt kostenlos anmelden!</button>
          </div>
        </div>

          <h3 class="mt-6">
            Deep Dive | Use Case
          </h3>

          <p>
            Wenn du sehen möchtest, wie KI in der Praxis eingesetzt wird.<br>
            Referenten: Koen Duenk (Senior Talent Acquisition Manager), Jonas Plaum (Co-Founder)
          </p>

          <p>
            Das erwartet dich:
          </p>

          <ul>
            <li class="mb-2">Was muss ich bei der Einführung von KI beachten?</li>
            <li class="mb-2">Wie kann der Einsatz von KI konkret aussehen? </li>
            <li class="mb-2">Welche Hürden und Best Practices gibt es? </li>
          </ul>

          <p>
            Termine
          </p>

          <ul>
            <li>05. August 2025</li>
            <li>23. September 2025</li>
            <li>18. November 2025</li>
          </ul>

        </div>

        <div class="row align-items-center mt-5">
          <div class="col-auto">
            <button class="btn btn-lg btn-round btn-primary" (click)="goToBooking('webinar-use-case-ki')">Jetzt kostenlos anmelden!</button>
          </div>
        </div>

        <!-- <a (click)="back();" class="link-arrow left text-uppercase small">Zurück</a> -->

      </div>

    </div>

  </div>

</section>
